/*
  Rí Sticky Add-to-Cart
  Shows a bottom-fixed bar on product pages once the user scrolls past the main
  buy box. Clicking the button clicks the nearest original add-to-cart button
  so it uses whatever cart-drawer / AJAX handler the theme already has.
*/
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    // still show, just no animations
  }
  if (!document.body || !document.body.classList) return;
  // Only on product pages
  var isProduct = document.body.classList.contains('template-product') ||
                  document.querySelector('main [id*="product"] form[action*="/cart/add"]');
  if (!isProduct) return;

  // Find the main add-to-cart form and button
  var mainForm = document.querySelector('main form[action*="/cart/add"]');
  if (!mainForm) return;
  var mainBtn = mainForm.querySelector('button[name="add"], button[type="submit"]');
  if (!mainBtn) return;

  // Pull product title + price from the page
  var titleEl = document.querySelector('.product-title, h1.product__title, .product-single__title, [data-product-title]');
  var priceEl = document.querySelector('.product__price .price, .price__regular .price-item, [data-product-price]');
  var imageEl = document.querySelector('.product-gallery img, .product__media img, .product-media img');

  var title = titleEl ? titleEl.textContent.trim() : 'Rí Sauna Crown';
  var price = priceEl ? priceEl.textContent.trim() : '';
  var imageSrc = imageEl ? imageEl.getAttribute('src') || imageEl.getAttribute('data-src') : '';

  // Build the sticky bar
  var bar = document.createElement('div');
  bar.className = 'ri-sticky-atc';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = ''
    + '<div class="ri-sticky-atc__inner">'
    +   (imageSrc ? '<img class="ri-sticky-atc__img" src="' + imageSrc + '" alt="" loading="lazy">' : '')
    +   '<div class="ri-sticky-atc__meta">'
    +     '<p class="ri-sticky-atc__title">' + title + '</p>'
    +     (price ? '<p class="ri-sticky-atc__price">' + price + '</p>' : '')
    +   '</div>'
    +   '<button type="button" class="ri-sticky-atc__btn">Add to Cart</button>'
    + '</div>';

  document.body.appendChild(bar);

  var stickyBtn = bar.querySelector('.ri-sticky-atc__btn');
  stickyBtn.addEventListener('click', function (e) {
    e.preventDefault();
    // Re-read button in case theme swapped it
    var currentBtn = mainForm.querySelector('button[name="add"], button[type="submit"]');
    if (currentBtn && !currentBtn.disabled) {
      currentBtn.click();
    }
  });

  // Show once user scrolls past the main buy box
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      } else if (entry.boundingClientRect.top < 0) {
        // Buy box has scrolled ABOVE viewport
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });

  observer.observe(mainForm);
})();
